<mm-spinner [loading]="tableState$"></mm-spinner>
<div class='errorMsgContainer' *ngIf="(tableState$ | async)?.hasError">
    <div class='documentWarning-icon'></div>
    <div class='main-msg'>Can't load {{params.noRowsMessageFn().tableName}}</div>
    <div class='secondary-msg'>Sorry for the inconvenience.<br>Please try again.</div>
    <a (click)="refreshAccount(accountId)" class='refresh-msg'>Refresh page</a>
</div>
<ng-template [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.isInitialLoad && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
        <div class='documentWarning-icon'></div>
        <div class='main-msg'>View {{params.noRowsMessageFn().tableName}}</div>
        <div class='secondary-msg'>Select an account and the<br>
            corresponding {{params.noRowsMessageFn().tableName}} will show up here.</div>
    </div>
</ng-template>
<ng-template [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.hasEmptyResponse && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
        <div class='main-msg'>{{noRowsMessageTemplates.standingAuthHeader}}</div>
    </div>
</ng-template>
